export default {
  routerName: "management",
  routes: [
    {
      path: "/management/sector",
      component: () => import("../management-library-sector-view"),
    },
  ],
};
